// extracted by mini-css-extract-plugin
export default {"tipClassName":"src-pages-SalesChannelContentEditor-SalesChannelEditorAllProductPage-Menu-css-module__tipClassName--R25PU"};